
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.999 20c0-7.72-6.28-14-14-14s-14 6.28-14 14 6.28 14 14 14 14-6.28 14-14zm-14 12c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12z"}}),_c('path',{attrs:{"d":"M51.999 20a20.03 20.03 0 00-6.667-14.908c-4.296-3.845-9.85-5.6-15.621-4.965-9.357 1.04-16.77 8.61-17.627 17.999-.928 10.181 6.01 19.436 15.915 21.449V46h-5c-2.206 0-4 1.794-4 4s1.794 4 4 4h5v6c0 2.206 1.794 4 4 4s4-1.794 4-4v-6h5c2.206 0 4-1.794 4-4s-1.794-4-4-4h-5v-6.424c9.321-1.883 16-9.984 16-19.576zm-17 28h6c1.102 0 2 .897 2 2s-.898 2-2 2h-6a1 1 0 00-1 1v7c0 1.103-.898 2-2 2-1.103 0-2-.897-2-2v-7a1 1 0 00-1-1h-6c-1.103 0-2-.897-2-2s.897-2 2-2h6a1 1 0 001-1v-8.26a1 1 0 00-.843-.987c-9.315-1.481-15.939-10.023-15.08-19.445.771-8.447 7.439-15.257 15.856-16.193 5.204-.578 10.201 1.008 14.066 4.467A18.032 18.032 0 0149.999 20c0 8.89-6.374 16.356-15.157 17.753a1 1 0 00-.843.987V47a1 1 0 001 1z"}})])
          )
        }
      }
    